<template>
  <section class="catalog-screen-wrapper">
    <div class="catalog-screen-container main-container">
      <medium-title
          :font-family="$isMobile
              ? 'EurostileR'
              : 'Eurostile'"
          class="main-title-container"
          v-animateonscroll="{ enterClass: 'fade-in'}">
        {{ mainTitle }}
      </medium-title>
      <div class="slider-wrapper"
           v-animateonscroll="{ enterClass: 'fade-in'}">
        <block-slider :info-cards="infoCard"
                      @changeId="value => idCard = value"
                      @actionClick="item => uploadFile(item.url, item.title)"
                      :is-active-static="$isMobile"
                      :class-name="'cards-catalog-wrapper'">
          <template v-slot:cardItem="item">
            <main-paragraph class="main-paragraph-container">
              {{ item.item.text }}
              <icon-default :size="'small'"
                            :icon="'download'"/>
            </main-paragraph>
          </template>
        </block-slider>
      </div>
    </div>

    <block-img-slider :img="activeItem?.img || 'catalog.webp'"/>
  </section>
</template>

<script>
import MediumTitle from "@/components/shared/text/MediumTitle.vue";
import BlockImgSlider from "@/components/entities/blocks/BlockImgSlider.vue";
import MainParagraph from "@/components/shared/text/MainParagraph.vue";
import IconDefault from "@/components/shared/IconDefault.vue";
import BlockSlider from "@/components/entities/blocks/BlockSlider.vue";
import SliderBanner from "@/components/entities/SliderBanner.vue";

export default {
  name: "CatalogScreen",
  components: {SliderBanner, BlockSlider, IconDefault, MainParagraph, BlockImgSlider, MediumTitle},
  data() {
    return {
      mainTitle: "Каталоги продукции",
      idCard: 0,
      infoCard: [
        {
          id: 0,
          title: 'Основной каталог 2025',
          url: 'catalog_1.pdf',
          img: 'catalogs/catalog_1.webp',
          text: 'Скачать PDF'
        },
        {
          id: 1,
          title: 'Каталог Патроны 2024',
          img: 'catalogs/catalog_2.webp',
          url: 'catalog_2.pdf',
          text: 'Скачать PDF'
        },
        {
          id: 2,
          title: 'Листовка Робот-сменщик 2024',
          img: 'catalogs/catalog_3.webp',
          url: 'catalog_3.pdf',
          text: 'Скачать PDF'
        }
      ]
    }
  },
  computed: {
    activeItem() {
      return this.infoCard.find(item => item.id === this.idCard)
    }
  },
}
</script>

<style scoped lang="scss">
.block-slider-img-container {
  height: 100% !important;
}
.catalog-screen-wrapper {
  position: relative;
  &:after {
    z-index: 0;
    pointer-events: none;
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--color-dark-medium-opacity-gradient);
  }
}
  .catalog-screen-container {
    position: relative;
    z-index: 1;
    flex-direction: column;
    height: fit-content;
  }

  .main-paragraph-container {
    cursor: pointer;
    color: var(--color-orange);
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  @media (max-width: 3024px){
    .catalog-screen-container {
      height: 1060px;
      row-gap: 60px;
      padding-top: 160px;
      padding-bottom: 160px;
    }

    .main-paragraph-container {
      column-gap: 12px;
    }
  }


  @media (max-width: 1920px) {
    .catalog-screen-container {
      height: 860px;
      padding-top: 120px;
      padding-bottom: 120px;
    }
  }
  @media (max-width: 1600px) {
    .catalog-screen-container {
      height: 812px;
      padding-top: 100px;
      padding-bottom: 100px;
    }

  }
  @media (max-height: 800px) {
    .catalog-screen-container {
      height: 600px;
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {
    .catalog-screen-container {
      height: 812px;
      padding-top: 100px;
      padding-bottom: 100px;
    }
  }

  @media (max-width: 1133px) {
    .catalog-screen-container {
      height: 600px;
    }
  }
  @media (max-width: 769px) {
    .catalog-screen-container {
      padding-top: 48px;
      padding-bottom: 48px;
      row-gap: 30px;
    }

    .main-paragraph-container {
      column-gap: 8px;
    }
    //iPhone 14
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    //iPhone Plus
  }
  @media (min-height: 600px) and (max-height: 630px){
    //для экранов 8 плюс
  }

  @media (max-width: 375px){
    //iPhone 8
  }


  @media (max-width: 375px) and (min-height: 630px) {
    //iPhone X
  }


  @media (max-width: 320px) {
    //iPhone SE
  }

  @media (min-width: 3025px) {
    .catalog-screen-container {
      height: 1892px;
      row-gap: 60px;
      padding: 280px 0;
    }

    .main-paragraph-container {
      column-gap: 12px;
    }
  }

</style>